import React from 'react'
import SocialContact from '../../common/social-contact'
import './about.css'

function About() {
    return (
        <div className='about'>
            <div className='about-top'>
                 <div className='about-info'>
                    Hello There 👋, I am a 
                    <br/> 25 y/o <span className='info-name'>Software Engineer</span>
                    <br/> 
                    <br/>
                    <br/> Currently:
                    <br/>
                    <br/> Building solutions with GenAI @ CIBC
                    <br/> Making AI videos at <a href="https://www.youtube.com/channel/UCTNGBpLPz95VB9I5KwYgjMA">ParagonAI</a>
                 </div>
                 <div className='about-photo'>
                    <img src='/profile.png' className='profile-photo'></img>
                    <SocialContact/>
                 </div>
                 
            </div>
           
        </div>
    )
}

export default About
